import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisViewDetailChartData, StatisticalAnalysisViewDetailChartFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.model'
import i18n from '@/lang/i18n'
import { Options } from 'highcharts'
import { StatisticalAnalysisSampleTagsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/labeled-samples-dossier/labeled-samples-dossier.model'
import { sampleTagsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.service'
import { StatisticalAnalysisSampleTagsStatisticsDossierBaseRequest, StatisticalAnalysisSampleTagsStatisticsDossierGroupRequest, StatisticalAnalysisSampleTagsStatisticsDossierGroupRequestEnum } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.dto'

export class StatisticalAnalysisHandlerChartSampleTagsDossier {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>) {
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
    }

    public async getChart(): Promise<Options> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisSampleTagsDossierExternalInfo
        const baseRequest: StatisticalAnalysisSampleTagsStatisticsDossierBaseRequest = sampleTagsStatisticsDossierService.getBaseRequest(sidebarFilter)
        const groupRequest: StatisticalAnalysisSampleTagsStatisticsDossierGroupRequest = {
            groupBy1: this.statisticalAnalysisFilters?.xAxis.groupBy1 as StatisticalAnalysisSampleTagsStatisticsDossierGroupRequestEnum,
            groupBy2: this.statisticalAnalysisFilters?.xAxis.groupBy2 as StatisticalAnalysisSampleTagsStatisticsDossierGroupRequestEnum
        }
        const tagId: number = sidebarFilter.trackingGeneralSelected?.key as number
        const response: StatisticalAnalysisViewDetailChartData = await sampleTagsStatisticsDossierService.getDetailViewChart(tagId, baseRequest, groupRequest)
        const groupedByCase: boolean = sidebarFilter.groupByCase as boolean
        return {
            xAxis: {
                categories: response.categories
            },
            yAxis: {
                title: {
                    text: `${i18n.tc(groupedByCase ? 'statisticalAnalysis.charts.totalCases' : 'statisticalAnalysis.charts.totalSamples')}`
                }
            },
            series: response.series
        }
    }
}
